import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const refreshShopifyPlan = {
  name: "refreshShopifyPlan" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.null(),
};
